import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import reducer from './reducer';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

export default configureStore({
    reducer,
    middleware: [
        ...getDefaultMiddleware({
            serializableCheck: false,
        }),
        // apiMiddleWare,
        sagaMiddleware,
    ],
    devTools: true,
});

export const bindActionToPromise = (dispatch, action) => payload => {
    return new Promise((resolve, reject) =>
        dispatch(action({ data: payload, resolve, reject })),
    );
};

sagaMiddleware.run(rootSaga);
